import useReimbursementStore from '../../../screens/Forms/useReimbursementStore';
import { ReactComponent as TrashIcon } from '../../../assets/images/trash.svg';
import styles from '../Reimbursement.module.css';

export const Delete = ({ row, field }) => {
    const deleteRow = useReimbursementStore((state) => state.deleteRow);
    const handleDeleteRow = (e) => {
        deleteRow(e.target.value, field, row.id);
    };
    return (
        <TrashIcon
            className={styles.trashIcon}
            onClick={handleDeleteRow}
        />
    );
};
